<template>
  <DealershipApplicationsList
    :items="applications"
    :pagination-data="paginationData"
    :is-loading="isLoading"
    @pageChange="getData"
    @onClickRow="onClickRow"
  />
</template>

<script>
import { mapGetters, mapState } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import DealershipApplicationsList from "@/views/settings/dealership-applications/index/_components/ApplicationsList.vue";
import { customerApplicationsQuery } from "@/views/settings/dealership-applications/index/gql/queries";
import DateService from "@/services/date.service";

export default {
  name: "DealershipApplicationsTab",

  components: { DealershipApplicationsList },

  mixins: [apolloMixin],

  data() {
    return {
      applications: [],
      paginationData: {},
      sorting: { column: "id", direction: "desc" },
      isLoading: false,
    };
  },

  computed: {
    ...mapState("dealershipApplications", ["applicationsFiltersForm"]),
    ...mapGetters("dealershipApplications", ["getStatus", "getSource", "getFilters"]),
  },

  watch: {
    applicationsFiltersForm: {
      handler: "onChangeFiltersForm",
      deep: true,
    },
  },

  created() {
    this.getData();
  },

  methods: {
    async getData(page = parseInt(this.$route.query.page) ?? 1) {
      this.isLoading = true;

      try {
        const rawFilters = this.getFilters(true) || {};
        const { date, ...filters } = rawFilters;

        let createdAtFrom = null;
        let createdAtTo = null;

        if (date?.from) {
          createdAtFrom = DateService.dateRangeFilterConverter(date.from, "from");
        }

        if (date?.to) {
          createdAtTo = DateService.dateRangeFilterConverter(date.to, "to");
        }

        const response = await this.$get(customerApplicationsQuery, {
          orderBy: this.sorting,
          page,
          filters: {
            ...filters,
            createdAtFrom,
            createdAtTo,
          },
        });

        this.applications = response?.customerApplications.data.map((application) => {
          const {
            id,
            companyName,
            companyCode,
            taxNumber,
            user,
            region,
            status,
            manager,
            createdAt,
            companyType,
            utmSource,
            utmCampaign,
            utmMedium,
            managerDeadline,
          } = application;

          const { firstName, lastName, roles, phone, email } = user;

          return {
            id,
            createdAt: DateService.dateConverter(createdAt, "datetime"),
            companyData: {
              type: companyType,
              name: companyName,
              code: companyCode ? companyCode : taxNumber,
              taxNumber: companyCode ? taxNumber : "",
            },
            userData: {
              primaryRow: `${lastName} ${firstName}`,
              secondaryRow: roles[0]?.name,
              phone,
              email,
            },
            region: region?.name[this.$i18n.locale],
            processingManager: manager?.name,
            campaign: utmCampaign,
            medium: utmMedium,
            source: this.getSource(utmSource),
            status: this.getStatus(status),
            managerDeadline,
            page: "DealershipApplicationsDetails",
          };
        });

        this.paginationData = response?.customerApplications?.paginatorInfo;
      } finally {
        this.isLoading = false;
      }
    },

    onChangeFiltersForm() {
      this.getData();
    },

    onClickRow(id) {
      this.$router.push({ name: "DealershipApplicationsDetails", params: { id } });
    },
  },
};
</script>
